







































import { Component, Prop, Vue } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { UserAPI } from '@/api/backend-client'

@Component
export default class ResetPasswordButton extends Vue {
    @Prop() readonly user!: User
    submitting: boolean = false
    showModal: boolean = false
    currentPassword: string = null
    newPassword: string = null
    newPasswordConfirm: string = null

    async changePassword(): Promise<void> {
        if (this.newPassword === this.newPasswordConfirm) {
            try {
                this.submitting = true
                await UserAPI.update(this.user.id, {
                    ...this.user,
                    password: this.newPassword,
                } as User)

                alert('Uw wachtwoord is aangepast. U dient nu opnieuw in te loggen met een nieuwe wachtwoord.')
                await UserAPI.logout()
                window.location.reload()

            } finally {
                this.submitting = false
            }
        }
    }
}
